var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHowItWorksRightCurve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 205,
    viewBox: "0 0 276 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M267.063 0.9997C273.256 20.3895 275.57 40.8093 273.872 61.0932C272.173 81.3771 266.497 101.128 257.165 119.218C247.834 137.308 235.031 153.383 219.487 166.525C203.943 179.667 185.963 189.619 166.574 195.812C147.184 202.005 126.764 204.319 106.48 202.621C86.1961 200.922 66.4453 195.245 48.3553 185.914C30.2653 176.583 14.1904 163.78 1.04834 148.236",
    stroke: "#FADAC8",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWorksRightCurve);
export default __webpack_public_path__ + "static/media/howItWorksRightCurve.068579b868e26d80f9f89e1c0fb6e3b5.svg";
export { ForwardRef as ReactComponent };